import React, { Component } from 'react';
import { Modal, List, Button, Spin, Typography, Space, Badge, Empty } from 'antd';
import { StarOutlined, CloseOutlined, WarningOutlined } from '@ant-design/icons';
import firebase from "../../firebase";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Text } = Typography;

class MobileFavoriteCartSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carts: [],
      loading: false,
    }
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.getCarts();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.getCarts();
    }
  }

  getCarts = async () => {
    const { db, user, org, userOrg } = this.props;
    if (!org || !user || !db) return;

    this.setState({ loading: true });

    let collection;
    if(org.reseller && userOrg && userOrg.maker) {
      collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
    } else if(org.maker && userOrg && userOrg.reseller) {
      collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
    } else if(org.reseller && userOrg && userOrg.buyer) {
      collection = db.collection('items_sell').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
    } else if(org.buyer && userOrg && userOrg.reseller) {
      collection = db.collection('items_sell').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
    }

    if (org && collection) {
      try {
        let fsRef = db.collection('favorite_set').doc(user.id).collection('favorite_set').doc(org.id);
        let fs = await fsRef.get();
        let fsData = fs.data();

        if (fsData) {
          for (let i = 0; i < 30; i++) {
            let cart = fsData[i];
            if (cart && cart.items) {
              let items = cart.items;
              delete cart.deletedItem;
              delete cart.deletedText;
              await Promise.all(items.map(async (item) => {
                let itemSell = await collection.doc(item.id).get();
                let itemSellData = itemSell.data();

                delete item.deletedItem;
                delete item.deletedText;

                if (!itemSellData) {
                  cart.deletedItem = true;
                  cart.deletedText = '販売終了商品が含まれています';
                  item.deletedItem = true;
                  item.deletedText = '販売終了商品が含まれています';
                } else if (!itemSellData.price || (itemSellData.price && itemSellData.price[0] && !itemSellData.price[0].price)) {
                  cart.deletedItem = true;
                  cart.deletedText = '要見積商品が含まれています';
                  item.deletedItem = true;
                  item.deletedText = '要見積商品が含まれています';
                } else if (itemSellData.price && itemSellData.price[0] && !itemSellData.price[0].expiration_date) {
                  cart.deletedItem = true;
                  cart.deletedText = '要見積商品が含まれています';
                  item.deletedItem = true;
                  item.deletedText = '要見積商品が含まれています';
                } else if (itemSellData.price && itemSellData.price[0] && itemSellData.price[0].expiration_date) {
                  let expiration_date = itemSellData.price[0].expiration_date;
                  let expDate = expiration_date.toDate();

                  if ((expDate.getTime() - this.props.dateNow) < 0) {
                    cart.deletedItem = true;
                    cart.deletedText = '価格有効期限切れ要見積';
                    item.deletedItem = true;
                    item.deletedText = '価格有効期限切れ要見積';
                  } else {
                    item.price = itemSellData.price[0].price;
                  }
                } else {
                  item.price = itemSellData.price[0].price;
                }

                if (!item.deletedItem) {
                  updateItemFromSellData(item, itemSellData);
                }
              }));
            }
          }
          this.setState({ carts: fsData });
        }
      } catch (error) {
        console.error("Error fetching favorite carts:", error);
      }
    }
    this.setState({ loading: false });
  }

  addCart = async (cartId) => {
    const { db, user, org, data } = this.props;
    let { carts } = this.state;
    
    if (!carts[cartId]) {
      carts[cartId] = { items: [] };
    }
    
    let cart = carts[cartId].items || [];
    const date = firebase.firestore.Timestamp.fromDate(new Date());

    const itemsToAdd = Array.isArray(data) ? data : [data];

    itemsToAdd.forEach(v => {
      const itemName = v['P4CLOUD商品名'] || '';
      const existing = cart.find(it => it.name === itemName);
      if (!existing) {
        cart.push({
          name: itemName,
          maker: v['正式メーカー名'] || '',
          code: v['販売企業商品コード'] || '',
          sellercode: v['仕入先事業所コード'] || '',
          sellername: v['仕入先事業所名'] || '',
          makeredicode: v['仕入先EDIコード商品コード'] || '',
          makerordercode: v['仕入先発注コード'] || '',
          price: v['price']?.[0]?.['price'] || 0,
          tax: v['消費税率'] || 0,
          id: v.id || v.objectID,
          count: 1,
          update: date,
        });
      } else {
        existing.count += 1;
        existing.update = date;
      }
    });

    carts[cartId].items = cart;
    carts[cartId].rejected = false;
    carts[cartId].created = carts[cartId].created || date;
    carts[cartId].latestUpdate = date;

    if (!carts[cartId].creatorUser) {
      carts[cartId].creatorUser = user.id;
      carts[cartId].creatorUserName = user.last_name + " " + user.first_name;
    }

    const cartMainRef = db.collection('favorite_set').doc(user.id);
    const cartRef = cartMainRef.collection('favorite_set').doc(org.id);

    try {
      await cartMainRef.set({ dummy: 'test' }, { merge: true });
      await cartRef.set({
        [cartId]: carts[cartId],
        update: date,
      }, { merge: true });
      this.props.onClose(true); // Close with "added" status
    } catch (error) {
      console.error("Error updating favorite cart:", error);
    }
  }

  render() {
    const { isOpen, onClose, userOrg, org } = this.props;
    const { carts, loading } = this.state;

    let isBuyer = false;
    if ((userOrg && userOrg.reseller && org && org.maker) || (userOrg && userOrg.buyer && org && org.reseller)) {
      isBuyer = true;
    }

    const cartList = Array.from({ length: 30 }, (_, i) => {
      const cart = carts[i] || {};
      const items = cart.items || [];
      
      let amount = 0;
      let hasArchive = false;
      
      items.forEach(it => {
        if (!it.deletedItem) amount += (it.price * it.count);
        if (it.archive) hasArchive = true;
      });

      let nameText = items.map(it => it.name).join(' / ');
      if (items.length === 0) nameText = '空です';

      let archiveMsg = '';
      if (hasArchive) {
        archiveMsg = isBuyer ? '取扱していない商品が含まれています' : 'アーカイブ商品が含まれています';
      }

      return {
        id: i,
        name: cart.cartName || `名称未設定`,
        items: items,
        amount: amount,
        deletedItem: cart.deletedItem,
        deletedText: cart.deletedText,
        requested: cart.requested,
        nameText: nameText,
        archiveMsg: archiveMsg,
      };
    });

    return (
      <Modal
        title={
          <Space>
            <StarOutlined style={{ color: '#faad14' }} />
            <Text>お気に入りセット選択</Text>
          </Space>
        }
        open={isOpen}
        onCancel={() => onClose(false)}
        footer={[
          <Button key="cancel" onClick={() => onClose(false)} block size="large">
            キャンセル
          </Button>
        ]}
        width="100%"
        style={{ top: 20, padding: '0 10px' }}
        bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '10px 0' }}
        closeIcon={<CloseOutlined />}
      >
        <div style={{ padding: '0 15px 10px 15px' }}>
          <Text type="secondary">追加するお気に入りセットを選択してください</Text>
        </div>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Spin size="large" tip="読み込み中..." />
          </div>
        ) : (
          <List
            itemLayout="horizontal"
            dataSource={cartList}
            renderItem={(item) => (
              <List.Item
                style={{ 
                    padding: '15px', 
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: item.requested ? '#fffbe6' : 'transparent'
                }}
                actions={[
                  <Button 
                    type="primary" 
                    onClick={() => this.addCart(item.id)}
                    disabled={item.requested}
                  >
                    {item.requested ? '承認待' : '選択'}
                  </Button>
                ]}
              >
                <List.Item.Meta
                  avatar={<Badge count={item.id + 1} style={{ backgroundColor: '#1677ff' }} />}
                  title={
                    <Space direction="vertical" size={0}>
                      <Text strong style={{ fontSize: '1.1rem' }}>
                        {item.name}
                      </Text>
                    </Space>
                  }
                  description={
                    <div style={{ marginTop: 8 }}>
                      <Text style={{ fontSize: '0.85rem' }} ellipsis={{ tooltip: item.nameText }}>
                        {item.nameText}
                      </Text>
                      {item.items.length > 0 && (
                        <div style={{ marginTop: 4 }}>
                          <Text strong style={{ color: '#d32f2f' }}>
                            {item.amount.toLocaleString()}円
                          </Text>
                        </div>
                      )}
                      {(item.deletedItem || item.archiveMsg) && (
                        <Space direction="vertical" size={0} style={{ marginTop: 4 }}>
                          {item.deletedItem && (
                            <Text type="danger" style={{ fontSize: '0.8rem', display: 'flex', alignItems: 'center' }}>
                              <WarningOutlined style={{ marginRight: 4 }} /> {item.deletedText}
                            </Text>
                          )}
                          {item.archiveMsg && (
                            <Text type="danger" style={{ fontSize: '0.8rem', display: 'flex', alignItems: 'center' }}>
                              <WarningOutlined style={{ marginRight: 4 }} /> {item.archiveMsg}
                            </Text>
                          )}
                        </Space>
                      )}
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        )}
      </Modal>
    );
  }
}

export default MobileFavoriteCartSelect;
